import Button from 'components/Form/Button';
import { EmptyChartIcon } from 'components/icons';
import React from 'react';
import styles from './emptystate.module.scss';

export default function EmptyState({
  text,
  handleClick,
  buttonText,
  showButton,
  headerText,
}) {
  return (
    <div className={styles.empty} data-testid="empty-state">
      <EmptyChartIcon data-testid="empty-chart-icon" />
      {headerText ? (
        <h3>{headerText}</h3>
      ) : (
        <h3>There’s nothing to see here</h3>
      )}
      <p>{text}</p>
      {showButton && (
        <Button onClick={handleClick} variant="primary">
          {buttonText}
        </Button>
      )}
    </div>
  );
}
